module.exports = __webpack_public_path__ + "img/icon_jczimu.007c4b45.svg";